import { CompaniesRescuenetRoutingModule } from './companies-rescuenet-routing.module';
import { InvoicesExternalService } from 'app/core/services/invoices-external.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { CompaniesRescuenetComponent } from './companies-rescuenet.component';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { NgModule } from '@angular/core';
import { EmailsInputModule } from 'app/utils/emails-input/emails-input.module';
import { PayorProfitCentersService } from '../payors/payor-profit-centers/payor-profit-centers.service';


@NgModule({
  imports: [
    CommonModule,
    CompaniesRescuenetRoutingModule,
    AgGridModule,
    Trip2ThemeModule,
    FormsModule,
    ReactiveFormsModule,
    EmailsInputModule
  ],
  declarations: [CompaniesRescuenetComponent],
  providers: [InvoicesExternalService, SweetAlertHelper, PayorProfitCentersService]
})
export class CompaniesRescuenetModule { }



// WEBPACK FOOTER //
// ./src/app/pages/companies-rescuenet/companies-rescuenet.module.ts